import { INTERAX_COLORS } from '../../../../constants/colors'

export const onboardingCardSx = {
  padding: '24px',
  // Muted dark slate to match the onboarding mock (subtler than the section blue).
  backgroundColor: 'rgba(40,52,60,0.72)',
  border: `1px solid ${INTERAX_COLORS.white10}`,
  borderRadius: '14px'
}

export const onboardingFieldLabelSx = {
  fontSize: 13,
  fontWeight: 600,
  color: INTERAX_COLORS.white70,
  mb: 1,
  letterSpacing: 0.2
}

export const onboardingStepHintSx = {
  fontSize: 14,
  color: INTERAX_COLORS.thunderGrey,
  mb: 2.5,
  lineHeight: 1.5
}

export const onboardingStepTitleSx = {
  fontSize: { xs: 22, sm: 26 },
  fontWeight: 600,
  color: INTERAX_COLORS.white,
  mb: 1
}
